import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullBusiness from "../fragments/fullBusiness"

const query = gql`
  query Businesses($q: String, $cursor: String) {
    businesses(q: $q, cursor: $cursor) {
      results {
        ...fullBusiness
      }
      hasMore
      cursor
      limit
    }
  }
  ${fullBusiness}
`

export const businessesKey = getQueryNames(query)[0]

export default query
